// 判断是否企业微信并且浏览器版本是否大于3.0.24
export const wxworkGE3_0_24 = function() {
  const ua = navigator.userAgent
  const result = ua.match(/wxwork\/([^\s]*)/i)
  if (!Array.isArray(result)) {
    return { version: 0, isWxwork: false, ge3_0_24: false } // 不是企业微信
  }
  const version = result[1].split(".").map(v => Number(v))

  if (
    version[0] > 3 ||
    (version[0] === 3 && version[1] > 0) ||
    (version[0] === 3 && version[1] === 0 && version[2] >= 24)
  ) {
    return { version: result[1], isWxwork: true, ge3_0_24: true } // 是企业微信，版本大于等于3.0.24；
  }
  return { version: result[1], isWxwork: true, ge3_0_24: false } // 是企业微信，版本小于3.0.24;
}

// 判断是否企业微信并且浏览器版本小于2.5.0
export const wxworkLT2_5_0 = function() {
  const ua = navigator.userAgent
  const result = ua.match(/wxwork\/([^\s]*)/i)
  if (!Array.isArray(result)) {
    return { version: 0, isWxwork: false, lt2_5_0: false } // 不是企业微信
  }
  const version = result[1].split(".").map(v => Number(v))
  if (
    version[0] < 2 ||
    (version[0] === 2 && version[1] < 5) ||
    (version[0] === 2 && version[1] === 5 && version[2] < 0)
  ) {
    return { version: result[1], isWxwork: true, lt2_5_0: true } // 是企业微信，版本小于2.5.0;
  }

  return { version: result[1], isWxwork: true, lt2_5_0: false } // 是企业微信，版本大于2.5.0;
}
